// extracted by mini-css-extract-plugin
export var aiStarIcon = "_tk-2";
export var container = "_tk-4";
export var dismissButton = "_tk-3";
export var hasPaddingBottom = "_tk-6";
export var last = "_tk-e";
export var scrollbarThumb = "_tk-c";
export var scrollbarTrack = "_tk-b";
export var selected = "_tk-9";
export var spin = "_tk-1";
export var spinning = "_tk-0";
export var suggestionItem = "_tk-d";
export var suggestionsPanel = "_tk-5";
export var tonePill = "_tk-8";
export var tonesContainer = "_tk-7";
export var unselected = "_tk-a";